module.exports = {"130983001":"骅东街道","130983002":"骅中街道","130983003":"骅西街道","130983100":"黄骅镇","130983101":"南排河镇","130983102":"吕桥镇","130983103":"旧城镇","130983104":"齐家务镇","130983105":"滕庄子镇","130983106":"常郭镇","130983107":"羊二庄镇","130983204":"官庄乡","130983207":"羊三木回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130983.json
// module id = 317
// module chunks = 0